/* Keep legacy Judge.me pagination in sync with the app's current grid totals.
   Scoped to our all-reviews page; product widgets retain their product counts. */
(() => {
  const root = document.querySelector('.j-reviews-page[data-review-total]');
  if (!root) return;
  const totals = {
    'product-reviews': Number(root.dataset.reviewProducts),
    'shop-reviews': Number(root.dataset.reviewShop)
  };
  const total = Number(root.dataset.reviewTotal);
  if (![total, ...Object.values(totals)].every(n => Number.isInteger(n) && n >= 0) ||
      totals['product-reviews'] + totals['shop-reviews'] !== total) return;
  const widget = root.querySelector('.jdgm-all-reviews-widget');
  if (!widget) return;
  let attached = false;
  let pending = false;
  const sync = () => {
    const $ = window.jdgm && window.jdgm.$;
    if (!$) return;
    const $widget = $(widget);
    // Filtered result counts belong to Judge.me, not the unfiltered shop total.
    const rating = $widget.data('filter-rating');
    const sort = widget.querySelector('.jdgm-sort-dropdown')?.value || ''; 
    if (sort.startsWith('with-') || (rating && rating !== 'null') || widget.querySelector('.jdgm-review-search')?.value.trim() ||
        widget.querySelector('.jdgm-chip.active')) return;
    Object.entries(totals).forEach(([scope, count]) => {
      const node = widget.querySelector(`[data-tabname="${scope}"] .jdgm-subtab__count`);
      if (node && node.textContent !== String(count)) node.textContent = String(count);
      const list = widget.querySelector(scope === 'product-reviews' ? '.jdgm-all-reviews__body' : '.jdgm-shop-reviews__body');
      if (list) {
        $(list).data('total-count', count);
        $(list).data('all-reviews-loaded', list.querySelectorAll('.jdgm-rev').length >= count);
      }
    });
    const summary = widget.querySelector('.jdgm-all-reviews__summary-text');
    const label = `${total} veröffentlichte Bewertungen`;
    if (summary && summary.textContent !== label) summary.textContent = label;
    const active = widget.querySelector('.jdgm-subtab__name.jdgm--active');
    const scope = active?.dataset.tabname || 'product-reviews';
    const list = widget.querySelector(scope === 'shop-reviews' ? '.jdgm-shop-reviews__body' : '.jdgm-all-reviews__body');
    const more = widget.querySelector('.jdgm-all-reviews-page__load-more-wrapper');
    if (list && more && !$(list).data('is-loading')) {
      more.classList.toggle('jdgm-hidden', list.querySelectorAll('.jdgm-rev').length >= totals[scope]);
    }
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; attach(); sync(); });
  };
  const attach = () => {
    const $ = window.jdgm && window.jdgm.$;
    if (attached || !$) return;
    attached = true;
    $(document).on([
      'jdgm.doneSetupARP.jaesaCounts',
      'jdgm.doneAppendMoreReviewsInAllReviewsPage.jaesaCounts',
      'jdgm.filteredInAllReviewsPage.jaesaCounts',
      'jdgm.openedTabInAllReviewsPage.jaesaCounts'
    ].join(' '), () => {
      // Before native loading completion checks, replace its stale total cache.
      sync();
      schedule();
    });
  };
  document.addEventListener('jdgm.doneSetup', () => { attach(); schedule(); });
  new MutationObserver(schedule).observe(widget, { childList: true, subtree: true });
  attach();
  schedule();
})();
